import { render } from "./FloatingFileNotesButton.vue?vue&type=template&id=5ca3dc5b&scoped=true"
import script from "./FloatingFileNotesButton.vue?vue&type=script&lang=js"
export * from "./FloatingFileNotesButton.vue?vue&type=script&lang=js"

import "./FloatingFileNotesButton.vue?vue&type=style&index=0&id=5ca3dc5b&scoped=true&lang=css"
import "./FloatingFileNotesButton.vue?vue&type=style&index=1&id=5ca3dc5b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ca3dc5b"]])

export default __exports__